const removeWallet = state => {
    const filteredWallets = state.get('customWallets').filter(wallet => {
        return wallet.get('idPortfolioAccount') !== state.get('customWalletIdToDelete');
    });

    return state.merge({
        customWallets: filteredWallets,
        isFetching: false,
        customWalletIdToDelete: null,
        customWalletNameToDelete: null,
        waitingCustomWalletConfirmationDelete: false,
    });
}

module.exports = {
    removeWallet
};
